import React, {Component, ReactNode} from 'react';
import {CollapseIcon, ExpandIcon} from 'components/Icon';
import {ToggledContent} from 'components/ToggledContent';
import './index.scss';

interface ExpandableItemProps {
  children: ReactNode;
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  className?: string;
}

interface ExpandableItemState {
  expanded: boolean;
}

export default class ExpandableItem extends Component<ExpandableItemProps, ExpandableItemState> {
  state = {
    expanded: false
  };

  onToggleExpandedClick = () => {
    this.setState({expanded: !this.state.expanded});
  };

  render() {
    const expanded = this.state.expanded;
    const className = `expandable-item ${this.props.className}`;
    return <section className={className}>
      <div className="header" onClick={this.onToggleExpandedClick}>
        {this.props.icon}
        <h2>{this.props.title}</h2>
        {this.props.description}
        <button className="expand-toggle">
          {expanded ? <CollapseIcon/> : <ExpandIcon/>}
        </button>
      </div>
      <ToggledContent className="content" visible={expanded}>
        {this.props.children}
      </ToggledContent>
    </section>;
  }
}